import axios from 'axios'
import { isNullOrUndefined } from 'util';

export default class ApiService {

    axiosInstance = null;

    // baseUrl; string | callbackResponse: function() | callbackError: function(status) | tokenJwt: string
    constructor(baseUrl, callbackResponse, callbackError) {
        this.axiosInstance = axios.create({
            baseURL: baseUrl,
            timeout: 60000,
        });

        // Suprimir logs no console do navegador (revelam a url da API)
        axios.defaults.validateStatus = false;
        
        // @BMONTEIRO: Adicionar headers para permitir CORS caso contrário a API pode não funcionar por estar em outro cluster na ECS
        this.axiosInstance.defaults.headers["Access-Control-Allow-Origin"] = '*';

        this.axiosInstance.interceptors.response.use(
            response => {
                if (response == undefined) { // Pode acontecer se API estiver offline
                    return Promise.resolve({
                        data: {
                            status: 500
                        }
                    })
                }

                if (response.status != 200) {
                    if (!isNullOrUndefined(callbackError)) {
                        callbackError(response);
                    }
                    
                    return Promise.reject(response);
                } else if (!isNullOrUndefined(callbackResponse)) {
                    callbackResponse(response);
                }

                return Promise.resolve(response);
            },

            error => {
                if (!isNullOrUndefined(callbackError)) {
                    callbackError(error);  
                } else {
                    return Promise.reject(error);
                }
            }
        );
    }

    basicAuth(resource, user, pass) {
        return this.axiosInstance.get(resource, {
            auth: {
                username: user,
                password: pass
            }
        });
    }

    setJwtToken(token) {
        this.axiosInstance.defaults.headers["Authorization"] = `Bearer ${token}`;
    }

    get(resource, data) {
        return this.axiosInstance.get(resource, data)
    }

    post(resource, data, options = null) {
        return this.axiosInstance.post(resource, data, options)
    }

    put(resource, data) {
        return this.axiosInstance.put(resource, data)
    }

    delete(resource, data) {
        return this.axiosInstance.delete(resource, { data: data })
    }

    customRequest(resource, data, config, get = false) {
        if (get) {
            return this.axiosInstance.get(resource, config)
        } else {
            return this.axiosInstance.post(resource, data, config)
        }
    }
}
